export const EDITING = 'EDITING'
export const VIEWING = 'VIEWING'
export const SEARCHING = 'SEARCHING'
